import { ThunkAction } from "redux-thunk";
import { Action, Dispatch } from "redux";
import IAppState from "../types/IAppState";
import {
    getAccountComponentDataFailure,
    getAccountComponentDataRequest,
    getAccountComponentDataSuccess,
    getAppVersionNumberFailure,
    getAppVersionNumberRequest,
    getAppVersionNumberSuccess,
    getCustomerDateConfigurationSuccess,
    getCustonerTimeZoneConfigurationSuccess,
    getCustomerDefaultTerritoriesSuccess,
    getCustomerSuccess,
    getUserCRMValuesSuccess,
    getUsersFailure,
    getUsersRequest,
    getUsersSuccess,
    loginFailure,
    loginRequest,
    loginSuccess,
    loginTypeFailure,
    loginTypeRequest,
    loginTypeSuccess,
    logoutFailure,
    logoutRequest,
    logoutSuccess,
    getUsageSearchResultConfigurationSuccess,
    getMemberNumberConfigurationSuccess,
    getRollUpTerritoriesConfigurationSuccess,
    getEnabledAdjustmentICEWorkSearchRequest,
    getEnabledAdjustmentICEWorkSearchSuccess,
    getEnabledAdjustmentICEWorkSearchFailure,
    getCatchUpAllocationsConfigurationSuccess,
    getAllPackagesDetailsSuccess,
    getAllPackagesDetailsFailure,
    getIPDetailsSuccess,
    getIPDetailsFailure,
    getAllocationCustomerTerritoryConfigurationSuccess,
    getCustomerContributorTypesConfigurationSuccess,
    getCustomerNamesTypesConfigurationSuccess,
    getCustomerIsUsageTabDefaultSetToMatchConfigurationSuccess,
} from "../reducers/AccountReducer";
import { AccountService } from "../../accounts/services/AccountService";
import { LookupService } from "../../lookup/services/LookupService"
import { ILoginViewModel } from "../../accounts/types/ILoginViewModel";
import { IAccountComponentData } from "../../accounts/types/IAccountComponentData";
import { ComponentFields } from "../../core/services/ComponentService";
import { IAADConfiguration } from "../../accounts/types/IAADConfiguration";
import { MATCHING_ENGINE, MEMBERS_PORTAL, CLIENTS, DEFAULT_CLIENT } from "../../accounts/Consts";
import { CUSTOMER_KEY, CUSTOMER_GROUP, CUSTOMER_DATE_KEY, CUSTOMER_DEFAULT_TERRITORIES, CUSTOMER_TIME_ZONE, USAGE_MAINTENANCE_KEY, USAGE_MAINTENANCE_NAME, MEMBER_NUMBER_KEY, JOB_GROUP, ADJUSTMENT_ICE_WORK_SEARCH_KEY, ENABLE_CATCHUP_ALLOCATIONS_CONFIGURATION, ALLOCATION_CONFIGURATION, CUSTOMER_TERRITORY, CONTRIBUTOR_TYPES_KEY, CUSTOMER_NAMES_TYPES_KEY, IS_USAGE_TAB_DEFAULT_SET_TO_MATCH, GET_ROLL_UP_TERRITORIES_KEY } from "../../home/Consts";
import { SearchRequests } from "../../repertoire/services/SearchRequests";
import { IB2CConfiguration } from "../../accounts/types/IB2CConfiguration";
import { IViewAsAccessRequest } from "../../membersportal/types/IViewAsAccessRequest";
import { IUsageSearcResultConfiguration } from "../../repertoire/types/usageTypes/IUsageSearcResultConfiguration";
import { IUserCRMValues } from "../../membersportal/types/IUserCRMValues"; 
import { hideModal, showLoading } from "../reducers/ModalReducer";
import { IInterestedParty } from "../../repertoire/types/IInterestedParty";
import { InterestedPartyDetailsMapper } from "../../repertoire/services/InterestedPartyDetailsMapper";
import { getViewAsAccessRequestsThunk } from "./MembersPortalThunks";
import { AppInsightsService } from "../../telemetry/services/AppInsightsService";
import { CURRENT_USER_EMAIL_KEY, CURRENT_USER_GUID_KEY, CURRENT_USER_NAME_KEY } from "../services/AccountSessionStorage";

export const getUsersThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getUsersRequest());
        return LookupService.getUsers()
            .then((res: string[]) => {
                dispatch(getUsersSuccess(res));
            })
            .catch((error: any) => {
                dispatch(getUsersFailure(error));
            });
    };
};

export const loginThunk = (viewModel: ILoginViewModel, redirect: any): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(loginRequest());
        return AccountService.login(viewModel)
            .then((res: string) => {
                var userProps = res.split(",");
                sessionStorage.setItem("isAuthenticated", "true");
                sessionStorage.setItem("isSignedIn", "true");
                sessionStorage.setItem(CURRENT_USER_NAME_KEY, viewModel.username);
                sessionStorage.setItem(CURRENT_USER_EMAIL_KEY, userProps[0]);
                sessionStorage.setItem(CURRENT_USER_GUID_KEY, userProps[2]);

                if (userProps[0]) {
                    AppInsightsService.setAuthenticatedUser(userProps[0]);
                }

                dispatch(loginSuccess(userProps[0], userProps[1]));
                if (redirect.search) {
                    window.location.href = redirect.pathname + redirect.search;
                }
            })
            .catch((error: any) => {
                sessionStorage.setItem("isAuthenticated", "false");
                sessionStorage.setItem("isSignedIn", "false");
                dispatch(loginFailure(error));
            });
    };
};

export const bootstrapMembersPortalAccountContextThunk = (
    userName: string
): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
    return async (dispatch: Dispatch) => {
        await dispatch<any>(getUserCRMValuesThunk());
        await dispatch<any>(getViewAsAccessRequestsThunk(userName));
    };
};

export const logoutThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return async (dispatch: Dispatch) => {
        dispatch(logoutRequest());
        
        try {
            await AccountService.logout();

            sessionStorage.setItem("isAuthenticated", "false");
			sessionStorage.setItem("isSignedIn", "false");
            sessionStorage.removeItem(CURRENT_USER_NAME_KEY);
            sessionStorage.removeItem(CURRENT_USER_EMAIL_KEY);
            sessionStorage.removeItem("menuItems");

            dispatch(logoutSuccess());
        } catch (error: any) {
            dispatch(logoutFailure(error));
        }

    };
};

export const getAccountComponentDataThunk = (): ThunkAction<
    void,
    IAppState,
    null,
    Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getAccountComponentDataRequest());
        return ComponentFields.getAccountComponentData()
            .then((res: IAccountComponentData) => {
                dispatch(getAccountComponentDataSuccess(res));
            })
            .catch((error: any) => {
                dispatch(getAccountComponentDataFailure(error));
            });
    };
};

export const getAppVersionNumberThunk = (): ThunkAction<
    void,
    IAppState,
    null,
    Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getAppVersionNumberRequest());
        return ComponentFields.getAppVersionNumber()
            .then((res: string) => {
                dispatch(getAppVersionNumberSuccess(res));
            })
            .catch((error: any) => {
                dispatch(getAppVersionNumberFailure(error));
            });
    };
};

export async function getAADLoginConfigurationThunk(): Promise<IAADConfiguration> {
    return await AccountService.getAADLoginConfiguration()
};

export async function getB2CLoginConfigurationThunk(): Promise<IB2CConfiguration> {
    return await AccountService.getB2CLoginConfiguration()
};

export const loginTypeThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(loginTypeRequest());
        return AccountService.loginType()
            .then((res: string) => {
                dispatch(loginTypeSuccess(res));
            })
            .catch((error: any) => {
                dispatch(loginTypeFailure(error));
            });
    };
};

export async function getPortalType(): Promise<string> {
    let result = await ComponentFields.getPortalType()
    if (result === MEMBERS_PORTAL)
        return MEMBERS_PORTAL;
    else
        return MATCHING_ENGINE;
};

export async function getClient(): Promise<string> {
    let result = await ComponentFields.getClient();
    if (CLIENTS.includes(result))
        return result;
    else
        return DEFAULT_CLIENT;
};

export const getCustomerThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return SearchRequests.getConfigurationParameter(CUSTOMER_KEY, CUSTOMER_GROUP)
            .then((res: string) => {
                dispatch(getCustomerSuccess(res));
            })
    }
}

export const getCustomerDefaultTerritoriesThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return SearchRequests.getConfigurationParameter(CUSTOMER_DEFAULT_TERRITORIES, CUSTOMER_GROUP)
            .then((res: any) => {
                dispatch(getCustomerDefaultTerritoriesSuccess(res));
            })
    }
}


export const getCustomerDateConfigurationThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return SearchRequests.getConfigurationParameter(CUSTOMER_DATE_KEY, CUSTOMER_GROUP)
            .then((res: string) => {
                dispatch(getCustomerDateConfigurationSuccess(res));
            })
    }
}

export const getCustomerIsUsageTabDefaultSetToMatchConfigurationThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return SearchRequests.getConfigurationParameter(IS_USAGE_TAB_DEFAULT_SET_TO_MATCH, CUSTOMER_GROUP)
            .then((res: boolean) => {
                dispatch(getCustomerIsUsageTabDefaultSetToMatchConfigurationSuccess(res));
            })
    }
}

export const getCustomerContributorTypesConfigurationThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return SearchRequests.getConfigurationParameter(CONTRIBUTOR_TYPES_KEY, CUSTOMER_GROUP)
            .then((res: string[]) => {
                dispatch(getCustomerContributorTypesConfigurationSuccess(res));
            })
    }
}
export const getCustomerNamesTypesConfigurationThunk = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
    return async (dispatch: Dispatch) => {
        try {
            const res: string[] = await SearchRequests.getConfigurationParameter(
                CUSTOMER_NAMES_TYPES_KEY,
                CUSTOMER_GROUP
            );

            dispatch(getCustomerNamesTypesConfigurationSuccess(res));
        } catch (error) {
            AppInsightsService.trackException(error, {
                properties: {
                    action: "getCustomerNamesTypesConfigurationThunk",
                    configurationKey: CUSTOMER_NAMES_TYPES_KEY,
                    configurationGroup: CUSTOMER_GROUP,
                },
            });

            console.error("Failed to load customer names types configuration", error);
        }
    };
};
export const getCustomerCatchUpAllocationsConfigurationThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return SearchRequests.getConfigurationParameter(ENABLE_CATCHUP_ALLOCATIONS_CONFIGURATION, ALLOCATION_CONFIGURATION)
            .then((res: boolean) => {
                dispatch(getCatchUpAllocationsConfigurationSuccess(res));
            })
    }
}

export const getCustomerTimeZoneConfigurationThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return SearchRequests.getConfigurationParameter(CUSTOMER_TIME_ZONE, CUSTOMER_GROUP)
            .then((res: string) => {
                dispatch(getCustonerTimeZoneConfigurationSuccess(res));
            })
    }
}

export const getAllocationCustomerTerritoryConfigurationThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return SearchRequests.getConfigurationParameter(CUSTOMER_TERRITORY, ALLOCATION_CONFIGURATION)
            .then((res: string) => {
                dispatch(getAllocationCustomerTerritoryConfigurationSuccess(res));
            })
    }
}

export const getUserCRMValuesThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return AccountService.getUserCRMValues()
            .then((res: IUserCRMValues) => {
                dispatch(getUserCRMValuesSuccess(res));
            })
    }
}

export const getMemberNumberConfigurationThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return SearchRequests.getConfigurationParameter(MEMBER_NUMBER_KEY, JOB_GROUP)
            .then((res: boolean) => {
                dispatch(getMemberNumberConfigurationSuccess(Boolean(res)));
            })
    }
}

export const getRollUpTerritoriesConfigurationThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return SearchRequests.getConfigurationParameter(GET_ROLL_UP_TERRITORIES_KEY, JOB_GROUP)
            .then((res: boolean) => {
                dispatch(getRollUpTerritoriesConfigurationSuccess(Boolean(res)));
            })
    }
}

export const getMyPackageDetailsThunk = (
    userName: string
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(showLoading()); 
        return SearchRequests.GetAllPackages(userName)
        .then((res) => {
            dispatch(getAllPackagesDetailsSuccess(res.data));
            dispatch(hideModal());
        })
        .catch(err => {
            dispatch(hideModal());
            dispatch(getAllPackagesDetailsFailure(err,userName));
        });
    }
};

export const getIPDetailsThunk = (
    ipBaseNumber?: string,
    accountNumber?: string,
    lookups?: any
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return SearchRequests.getIP(ipBaseNumber, accountNumber)
            .then((res: IInterestedParty) => {
                
                let ipResult: IInterestedParty = {
                    ...res,
                    socIP: {
                        ...res.socIP,
                        ipRepresentations: InterestedPartyDetailsMapper.mapInterestedPartStatetoState(res.socIP, lookups)
                    }
                };
                dispatch(getIPDetailsSuccess(ipResult));
            })
            .catch(err => {
                dispatch(hideModal());
                dispatch(getIPDetailsFailure(err, ipBaseNumber, accountNumber));
            });
    }
}



export const getUsageSearchResultConfigurationThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return SearchRequests.getConfigurationParameter(USAGE_MAINTENANCE_KEY, USAGE_MAINTENANCE_NAME)
            .then((res: IUsageSearcResultConfiguration) => {
                dispatch(getUsageSearchResultConfigurationSuccess(res));
            })
    }
}

export const getUserCRMIpNumberByGuidThunk = (
    guid: string
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {

        return AccountService.getUserCRMIpNumber(guid)
            .then((res: IUserCRMValues) => {
                dispatch(getUserCRMValuesSuccess(res));
        })
    }
}

export const getEnabledAdjustmentICEWorkSearchThunk  = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getEnabledAdjustmentICEWorkSearchRequest());
                return SearchRequests.getConfigurationParameter(ADJUSTMENT_ICE_WORK_SEARCH_KEY , CUSTOMER_GROUP)
                    .then((res: boolean) => {
                        dispatch(getEnabledAdjustmentICEWorkSearchSuccess(res));
                    })
                    .catch((error: any) => {
                        dispatch(getEnabledAdjustmentICEWorkSearchFailure(error));
                    });
    }
}
